export default __webpack_public_path__ + "static/sim_logo_new-9166ab24f9c219809d607524f955c789.png";